import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
  isLoggedIn: false,
};

export const ContextProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(null);
  const [suppoertChatId, setSuppoertChatId] = useState(null);
  const [currentColor, setCurrentColor] = useState("#03C9D7");
  const [currentMode, setCurrentMode] = useState("Light");
  const [themeSettings, setThemeSettings] = useState(false);
  const [addToTopRatedSideBar, setAddToTopRatedSideBar] = useState(false);
  const [addToSaleSideBar, setAddToSaleSideBar] = useState(false);
  const [addToSetsSideBar, setAddToSetsSideBar] = useState(false);
  const [editSaleProductsBar, setEditSaleProductsBar] = useState(false);
  const [chnageStatus, setChnageStatus] = useState(false);
  const [changeStatusRequests, setChangeStatusRequests] = useState(false);
  const [changeStatusBookRequests, setChangeStatusBookRequests] = useState(null);
  const [activeMenu, setActiveMenu] = useState(true);
  const [isClicked, setIsClicked] = useState(initialState);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const setMode = (e) => {
    setCurrentMode(e.target.value);
    localStorage.setItem("themeMode", e.target.value);
  };

  const setColor = (color) => {
    setCurrentColor(color);
    localStorage.setItem("colorMode", color);
  };

  const handleClick = (clicked) =>
    setIsClicked({ ...initialState, [clicked]: true });

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <StateContext.Provider
      value={{
        currentColor,
        currentMode,
        activeMenu,
        screenSize,
        setScreenSize,
        handleClick,
        isClicked,
        initialState,
        setIsClicked,
        setActiveMenu,
        setCurrentColor,
        setCurrentMode,
        setMode,
        setColor,
        themeSettings,
        setThemeSettings,
        isLoggedIn,
        setIsLoggedIn,
        setAddToTopRatedSideBar,
        addToTopRatedSideBar,
        addToSaleSideBar,
        setAddToSaleSideBar,
        addToSetsSideBar, setAddToSetsSideBar,
        editSaleProductsBar, setEditSaleProductsBar,
        chnageStatus,
        setChnageStatus,
        changeStatusRequests, setChangeStatusRequests,
        changeStatusBookRequests, setChangeStatusBookRequests,
        suppoertChatId, setSuppoertChatId
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
